/**
 * Copyright (c) 2019 2020 7thCode. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

import {UpdatableService} from "../../platform/base/services/updatable.service";

/**
 * todo
 */
@Injectable({
	providedIn: "root",
})

export class InquiriesService extends UpdatableService {

	/**
	 *
	 * @param http
	 */
	constructor(
		public http: HttpClient,
	) {
		super(http, "inquiries");
	}

	/**
	 * @returns none
	 */
	protected decorator(value: any): any {
		return value;
	}

}
